export const fj = {
  msg: {
    username: 'Yaca me vakayagataki',
    password: 'Vosanicuru',
    verification_code: 'iVola ni Vakadeitaki',
    product: 'iYaya Gadrevi Me Kerei',
    login: 'Saini Curu e loma',
    changeLanguage: '',
    'lang-en': 'English',
    'lang-ms': 'Bahasa Melayu',
    submit_button_text: 'Vakauta',
    enter: 'mo vola',
    en: 'English',
    ms: 'Bahasa Melayu',
    id: 'Bahasa Indonesia',
    zh: 'Chinese',
    to: 'Tonga',
    sm: 'Samoan',
    fj: 'Fijian',
    copyright: 'Yavalati ena Global Psytech',
    new_password: 'Vosanicuru vou',
    confirm_new_password: 'Vakadeitaki na Vosanicuru Vou',
    forgot_password_header: 'Guilecava na',
    confirm_password_header: 'Vakadeitaka na Vosanicuru',
    basic_info: 'Basic Information',
    password_set: 'Kerea mo vakacuruma na vosanicuru',
    sign_up: 'Vakalewena Taumada',
    sign_up_1: 'Tubutubu ni Matai Waka?&nbsp',
    sign_up_2: 'Tiko ki te tikina na Saini.',
    note: 'Nanuma: E dodonu mo volai taumada ni bera ni curu.',
    already_signed_up: 'O sa volai oti e na vatavata oqo? Vakacurumu na nomu ivola ni vakadeitaki (code) mo curu kina.',
    product_info: 'iYaya Gadrevi Me Kerei',
    continue: 'Tomani',
    back: 'Lesu',
    cancel_reset: 'Bokoca',
    forgot_password: 'Guilecava na Vosanicuru?',
    sign_up_message: 'mo tauyavutaka e dua na akaude',
    reset_success: 'Kerei mo ni saini curu e nomuni vosanicuru vou.',
    dpa_heading: 'Veiyalayalati ni Tukutuku Taqomaki Vakatamata Yadua. ',
    dpa_body1: 'E yalataka eke na GFI ni na tomana me karona na itukutuku vuni era soli mai ka salavata kei na Lawa ni Taqomaki ni Tukutuku.  Ena vuku ni kena vakamuri ka tutaki na vakatulewa ni kena maroroi na itukutuku vakasokomuni mai ena veitaro oqo ena vakauti walega vua e dabeca na veitarogi se vua sa vakadonui me matataki koya.',
    dpa_body2: 'Na itukutuku kece era na maroroi ka vakauti vakavinaka me ra yaco taudonu ka taqomaki, se mani tiko e Viti se na taudaku kei Viti o koya e dabeca na veitarogi.',
    dpa_body3: 'Dua tale na veitaratara e muri ena vuku ni kena vakayagataki na itukutuku ena vakatautaki ki na veiyalayalati taumada nei koya e dabeca na veitarogi kei koya e veitalai mai. ',
    close: 'Sogota',
    reset_button: 'Vakauta',
    successfully_register: 'Sa mai cava vinaka na nomuni vakalewe fomu. Kerei mo ni sainicuru ena yacavakayagataki kei na vosanicuru.',
    cloned_user: 'E sa vakabau tikoga nomuni maka ni GFI sa oti.  E sa na sega ni gadrevi mo dabeca tale e dua na veitarogi.',
    password_changed: 'Kerei mo ni saini curu e nomuni vosanicuru vou.',
    loading_text: 'Vakavodoka tiko...',
    month_label: 'Vakavula',
    create_registration: 'Mo tauyavutaka e dua na nomu yacavakayagataki se na vosanicuru.',
    otp: 'OTP',
    emailAddress: 'imeli',
    login_instruction: 'I Vakaro',
    login_instruction_title: 'Ni bera ni tekivutaka na vakadidike, vakadeitaka mada na veika oqo:',
    login_instruction_1_heading: 'iTukutuku me baleta na vakadidike ena initaneti (online)',
    login_instruction_1: ' – Wilika vinaka na ivakamacala kece ni bera ni tekivu.',
    login_instruction_2_heading: 'Digitaka e dua',
    login_instruction_2: ' – na vanua galala ka vakagagalu ka sega ni dua ena vakasosa taki iko kina.',
    login_instruction_3_heading: 'Wasea na gauna',
    login_instruction_3: ' – Vakarau taka e dua na tikini gauna me rawa ni oti vakadua na saumi taro.',
    user_guide: 'iDusidusi ni Vakayagataki'
  },
  error: {
    full_name_required: 'Kerea mo vakacuruma na yacamuni taucoko e volai tiko ena nomuni vola ni vakadinadina',
    full_name_min: 'Na yaca taucoko me kakua ni lailai mai na 5 na matanivola.',
    full_name_max: 'Na yaca taucoko me kua ni sivia mai na 80 na matanivola.',
    full_name_regex: 'Era ciqomi walega na ivakatakilakila ni matanivola, vanua e lala ena kedra maliwa kei na: @ ‘- kei na /',

    first_name_required: 'Vakacuruma mada na yacamu taumada me vaka e volai ena nomu ID vakadonui.',
    first_name_min: 'Na matai ni yacamu me sivia e tolu na iwiliwili ni matanivola.',
    first_name_max: 'Na matai ni yacamu me kua nu sivia e walusagavulu na iwiliwili ni matanivola.',
    first_name_regex: 'E vakatarai ga na matanivola, na vanua lala (spaces vaka peratania) kei na vica walega na matanivola vakatakilakila oqo: @ ‘ – kei na /',

    last_name_required: 'Vakacuruma mada na otioti ni yacamu me vaka e volai ena nomu ID vakadonui.',
    last_name_min: 'Na otioti ni yacamu sivia e tolu na iwiliwili ni matanivola.',
    last_name_max: 'Na otioti ni yacamu me kua nu sivia e walusagavulu na iwiliwili ni matanivola.',
    last_name_regex: 'E vakatarai ga na matanivola, na vanua lala (spaces vaka peratania) kei na vica walega na matanivola vakatakilakila oqo: @ ‘ – kei na /',

    id_num_required: 'Kerea mo vola na nomu naba ni IV',
    id_num_min: 'Na naba ni IV me e 3 na matanivola.',
    id_num_max: 'Na nab ani IV me sivia e 20 na imatanivola.',
    id_num_regex: 'Era ciqomi walega na ivakatakilakila ni matanivola, matanifika, kei na veivakatakilakila oqo: -  kei na /.',

    customer_id_required: 'Kerei mo ni vakacuruma nomuni IV.',
    customer_id_min: 'Na naba ni IV me kena lailai e 3 na matanivola.',
    customer_id_max: 'Na naba ni IV me sivia e 20 na imatanivola.',
    customer_id_regex: 'Era ciqomi walega na ivakatakilakila ni matanivola, matanifika, kei na veivakatakilakila oqo: -  kei na /.',

    applicationNumber_required: 'Kerei mo ni vakalewena nomuni naba ni kerekere.',
    applicationNumber_min: 'Na naba ni IV me e 3 na matanivola.',
    applicationNumber_max: 'Na nab ani IV me sivia e 10 na imatanivola.',
    applicationNumber_regex: 'Na ivakatakilakila ga e ciqoma sa ikoya na matanivola kei na matanifika',
    applicationNumber_duplicate: 'Duplicate Naba ni Kerekere',

    applicationnumber_required: 'Kerei mo ni vakalewena nomuni naba ni kerekere.',
    applicationnumber_min: 'Na naba ni kerekere me kakua ni lailai mai na 3 na matanivola. ',
    applicationnumber_max: 'Na nab ani IV me sivia e 10 na imatanivola.',
    applicationnumber_regex: 'Na ivakatakilakila ga e ciqoma sa ikoya na matanivola kei na matanifika',
    applicationnumber_duplicate: 'Duplicate Naba ni Kerekere',

    email_address_required: 'Please enter the email address.',
    email_address_min: 'Na naba ni IV me e 3 na matanivola.',
    email_address_max: 'Na nab ani IV me sivia e 20 na imatanivola.',
    email_address_regex: ' Invalid email address',

    otp_required: 'Please enter the OTP.',
    otp_min: 'Na naba ni IV me e 6 na matanivola.',
    otp_max: 'Na nab ani IV me sivia e 6 na imatanivola.',
    otp_regex: ' Invalid OTP',
    invalid_otp: 'Invalid OTP',

    business_reg_required: 'Kerea mo ni vola na yaca vakacurumi ni bisinisi/ naba ni laiseni ni bisinisi.',
    business_reg_max: ' The business registration/ business license number must not be longer than 20 characters.',
    business_reg_min: 'Na naba ni vakacuru bisinisi me kakua ni lailai mai na 5 na tamanivola.',
    business_reg_regex: 'Era ciqomi walega na ivakatakilakila ni matanivola, vanua e lala ena kedra maliwa, matanifika, kei na veivakatakilakila oqo: . - & () kei na ’',

    company_name_required: 'Kerea mo vakacuruma na yaca ni nomu kabani.',
    company_name_min: 'Na yaca taucoko me kakua ni lailai mai na 5 na matanivola.',
    company_name_max: 'Na yaca taucoko me kua ni sivia mai na 80 na matanivola.',
    company_name_regex: 'Era ciqomi walega na ivakatakilakila ni matanivola, vanua e lala ena kedra maliwa, matanifika, kei na veivakatakilakila oqo: . - & () kei na ’ .',

    business_category_required: 'Select business category',
    product_applied_required: 'Kerea mo digitaka na iyaya kerei mai',
    commencement_date_required: 'Yalovinaka vakacuruma na tikinisiga ni itekitekivu ni bisinisi ni nomu kabani.',
    facility_required: 'Please select the facilities you are applying',
    facilities_required: 'Please select the facilities you are applying.',

    amount_applied_required: 'Kerea mo vola na levu ni lavo e kerei.',
    amount_applied_maxvalue: 'Na levu ni lavo e kerei me kakua ni sivia mai na {1}.',
    amount_applied_minvalue: 'Na levu ni lavo e kerei me kakua ni lailai mai na {0}',

    tenure_required: 'Kerea mo vola na balavu ni gauna ni veivakaivolataki ko na gadreva.',
    tenure_maxvalue: 'Me kakua ni sivia mai na {1} na vula.',
    tenure_minvalue: 'Me kakua ni lailai mai na {0} na vula ',

    officerinchargeid_required: 'Please enter the ID number of Loan Officer you are dealing with.',
    officerinchargeid_invalid: 'Invalid Loan Officer ID. Please enter the correct Loan Officer ID.',
    officerinchargeid_regex: 'The only acceptable characters are letters of the alphabet, numeral and the following special characters: ! # - and @',
    officerinchargeid_min: 'The ID must be at least 6 characters long.',
    officerinchargeid_max: 'The ID number cannot be longer than 15 characters',

    username_required: 'Kerea mo vakacuruma na yacavakayagataki.',
    username_min: 'Nomuni yacavakayagataki me kena ni lailai  na 6 na matanivola.',
    username_max: 'Nomuni yacavakayagataki me kakua ni sivia na 15 na matanivola.',
    username_regex: 'Era ciqomi ga na ivakatakilakila vakamatanivola, vakafika, kei ira oqo: ! # - kei na @ .',
    username_duplicate: 'Yacavakayagataki e sa vakayagati oti. Kerea me volai e dua tale na yacavakayataki.',

    product_required: 'Please enter a Product/Programme.',
    product_min: 'Your Product/Programme must be at least 6 characters long.',
    product_max: 'Your Product/Programme cannot be longer than 15 characters.',
    product_regex: 'The only acceptable characters are letters of the alphabet, numeral and the following special characters: ! # - and @',

    password_required: 'Kerea mo vola e dua na vosanicuru.',
    password_min: 'Nomuni vosanicuru me kua ni lailai mai na 6 na matanivola.',
    password_max: 'Nomuni vosanicuru me kua ni sivia na 15 na matanivola.',
    password_regex: 'Era ciqomi ga na ivakatakilakila vakamatanivola, vakafika, kei ira oqo: ! # - kei na @ .',
    confirm_password_regex: 'Era ciqomi ga na ivakatakilakila vakamatanivola, vakafika, kei ira oqo: ! # - kei na @ .',
    new_password_regex: 'Era ciqomi ga na ivakatakilakila vakamatanivola, vakafika, kei ira oqo: ! # - kei na @ .',

    confirm_password_required: 'Kerei mo vola tale na nomu vosanicuru me vakadeitaki.',
    confirm_password_confirmed: 'Nomuni vosanicuru kei na vosanicuru e vakadeitaki erau sega ni veisotari.',
    confirm_password_min: 'Nomuni vosanicuru me kua ni lailai mai na 6 na matanivola.',
    confirm_password_max: 'Nomuni vosanicuru me kua ni sivia na 15 na matanivola.',

    registrationtoken_required: 'Vakacuruma mada na ivola ni vakadeitaki e soli vei iko',
    registrationtoken_min: 'Nomuni kodi ni veivakamatatataki me rauta ga e 6 na ivakatakilakila ',
    registrationtoken_max: 'Nomuni kodi ni veivakamatatataki me rauta ga e 6 na ivakatakilakila ',
    registrationtoken_duplicate: 'E cala na kodi ni veivakamatatataki. Kerei mo vakacuruma na kena e dodonu.',
    registrationtoken_regex: 'Ciqomi ga na ivakatakilakila vakamatanivola kei na kena vakafika.',
    registrationtoken_invalid: 'E cala na kodi ni veivakamatatataki. Kerei mo vakacuruma na kena e dodonu.',

    confirm_password_placeholder: 'Kerei mo vola tale na nomu vosanicuru me vakadeitaki.',

    error: 'Sega ni vakabau na nomu yacavakayagataki se na vosanicuru.',
    registration_error: 'Sega ni raw ani vakayacori na nomuni kerekere. Kerea mo tovolea tale.',
    new_password_required: 'Vakadeitaki ni vosanicuru vou',
    confirm_new_password_required: 'Kerei mo vola tale na nomu vosanicuru me vakadeitaki.',
    invalid_credentials: 'Sega ni vakabau na nomu yacavakayagataki se na vosanicuru.',

    consent_required: 'Ni bera nomuni vakacurumi mai, mo wilika na Veiyalayalati ni Tukutuku Taqomaki Vakatamata Yadua ka ciqoma ena nomuni sa toqa na lomanibai vakarautaki.',

    reset_invalid: 'We are unable to find your account by the details provided.',
    new_password_min: 'Nomuni vosanicuru me kua ni lailai mai na 6 na matanivola.',
    new_password_max: 'Nomuni vosanicuru me kua ni levu main a 15 na matanivola.',
    confirm_new_password_min: 'Nomuni vosanicuru me kua ni lailai mai na 6 na matanivola.',
    confirm_new_password_max: 'Nomuni vosanicuru me kua ni levu main a 15 na matanivola.',
    confirm_new_password_confirmed: 'Nomuni vosanicuru kei na vosanicuru e vakadeitaki erau sega ni veisotari.',
    register_username_details_does_not_match: 'Nomuni naba ni IV kei/se naba ni BR erau sega ni veisotari kei na ivolatukutuku ni vakalewe fomu.',
    register_username_not_found: 'Guilecava na vosavakayagataki? Kerea mo veitaratara kei na tabana ni veivuke.',
    data_tempered: 'Unable to reset your password. Please try again later.',
    branch_required: 'Kerea mo digitaka e dua na Tabacakacaka',
    drop_down_not_available: 'No data available',
    repeating_user: 'Vosota sa tao nomuni vakalewe fomu.\n.',
    duplicate: 'Yacavakayagataki e sa vakayagati oti. Kerea me volai e dua tale na yacavakayataki vou.',
    duplicateApplication: 'Duplicate Application Number.',
    incompleteAssessment: 'Vosota ni sa mai tao na nomuni vakaleweni fomu. User available with incomplete assessment',
    invalid_amount: 'Vosota ni sa mai tao na nomuni vakaleweni fomu. Invalid Financing Amount',
    invalid_tenure: 'Vosota ni sa mai tao na nomuni vakaleweni fomu. Invalid Financing Tenure',

    id_type_required: 'Kerea mo digitaka e dua na mataqali IV (iTukutuku ni Vakadinadina)',
    br_type_required: 'Please select Business Registration type.',

    invalid_username_email: 'E sega ni tiko na yacavakayagataki qo.',

    verification_code_required: 'Vakacuruma mada na ivola ni vakadeitaki e soli vei iko.',
    verification_code_min: 'Na nomu ivola ni vakadeitaki me ono na ivakatakilakila kina.',
    verification_code_max: 'Na nomu ivola ni vakadeitaki me ono na ivakatakilakila kina.',
    verification_code_duplicate: 'Na ivola ni vakadeitaki e cala. Vakacuruma tale na ivola ni vakadeitaki dodonu.',
    verification_code_regex: 'Na ivakatakilakila e rawa ga ni vakayagataki o ira na matanivosa kei na iwiliwili.',
    verification_code_0: 'Na nomu ivola ni vakadeitaki me ono na ivakatakilakila kina.'

  },
  registration: {
    full_name: 'Yacamuni Taucoko',
    first_name: 'Matai ni yacamu',
    last_name: 'Otioti ni yacamu',
    customer_id: 'IV nei koya e Veivoli',
    applicationNumber: 'Naba ni Vola Kerekere',
    email_address: 'imeli',
    otp: 'OTP',
    id_num: 'Naba ni iTukutuku ni Vakadinadina (IV)',
    business_reg: 'Vakacurumi ni Bisinisi/ Naba ni Laiseni ni Bisinisi',
    company_name: 'Yaca ni Kabani',
    product_applied: 'iYaya Gadrevi Me Kerei',
    commencement_date: 'Tikinisiga ni Itekitekivu ni Bisinisi',
    facilities: 'Facilities Applied',
    amount_applied: 'Levu ni Lavo e Kerei ($)\n',
    tenure: 'Balavu ni Veivakalavotaki (Vakavula)',
    business_category: 'Cava nomu bisinisi',
    confirm_password: 'Vakadeitaka na Vosanicuru',
    verification_code: 'iVola ni Vakadeitaki',
    consent1: 'Au sa wilika ka kila vakamatata na',
    consent2: 'Veiyalayalati ni Tukutuku Taqomaki Vakatamata Yadua',
    consent3: 'kau ciqoma e noqu sa toqa na lomanibai e vakarautaki ena Veiyalayalati.',
    cancel: 'Bokoca',
    register: 'Vakaleweni fomu',
    branch: 'Tabana/Tabacakacaka',
    officer: 'Loan Officer ID No.',
    id_type: 'Veimataqali Vakadinadina ni Tukutuku Tudei',
    br_type: 'Vakacurumi ni Bisinisi/ Naba ni Laiseni ni Bisinisi'
  }
}
